import React, { ReactElement } from 'react';
import PortAndWaterwayObjectList from './port-and-waterway-object-list';
import ListFilter from './list-filter';
import PageWithSidebar from '../../../../features/list-page-with-filter/components/page-with-sidebar';

export default function ListPage(): ReactElement {
  return <PageWithSidebar sideBar={<ListFilter />} mainContent={<PortAndWaterwayObjectList />} />;
}
